import React from 'react';
import PropTypes from 'prop-types';
import Button from '../Button';
import IconBadge from '../IconBadge';
import SearchPill from '../SearchPill';

import './SearchCollection.scss';
import MoreEllipsis from '../../svg/icons/more-horizontal.svg';
import Arrow from '../../svg/icons/arrow.svg';
import TranslationProvider, { getTranslation } from '../../providers/TranslationProvider';

const SearchCollection = (props) => {
  const {
    isMobile,
    collectionData,
    setSelectedCollection,
    displayMoreCollections,
    toggleDisplay,
  } = props;

  if (collectionData.length < 1) return null;

  const topRowLimit = isMobile ? 4 : 7;
  const nonPlatinumCollectionData = collectionData?.filter((collection) => collection.collectionSlug !== 'amex-platinum-nights');
  const firstNCollections = nonPlatinumCollectionData.slice(0, topRowLimit);
  const remainingCollections = nonPlatinumCollectionData.slice(topRowLimit);
  const shouldDisplayMoreIcon = !!remainingCollections.length;

  const renderCollections = (data) => data.map(
    (current) => (
      <SearchPill
        url={current.urlSlug}
        iconName={current.icon.path}
        name={current.icon.name}
        onClick={() => setSelectedCollection(current)}
        shortName={current.shortName}
      />
    )
  );

  const renderDisplayMoreButton = () => (
    <Button
      className="SearchPill"
      onClick={toggleDisplay}
      variant="no-style"
      aria-label={displayMoreCollections
        ? getTranslation({
          translationKey: 'less',
          fallback: 'Less',
        })
        : getTranslation({
          translationKey: 'more',
          fallback: 'More',
        })}
      aria-expanded={displayMoreCollections}
    >
      {displayMoreCollections && (
        <IconBadge
          className="search-collections-less-button"
          component={Arrow}
          label="Less"
          size="54"
          bgToSvgRatio="2"
          background="#fafafa"
        />
      )}
      {!displayMoreCollections && (
        <IconBadge
          component={MoreEllipsis}
          label="More"
          name="more-collections"
          size="54"
          bgToSvgRatio="2"
          background="#fafafa"
        />
      )}
      {displayMoreCollections ? (
        <TranslationProvider translationKey="less"><p>Less</p></TranslationProvider>
      ) : (
        <TranslationProvider translationKey="more"><p>More</p></TranslationProvider>
      )}
    </Button>
  );

  return (
    <div className="Search-Collections-Container">
      <div className="search-collections">
        {renderCollections(firstNCollections)}
        {displayMoreCollections && renderCollections(remainingCollections)}
        {shouldDisplayMoreIcon && renderDisplayMoreButton()}
      </div>
    </div>
  );
};

SearchCollection.propTypes = {
  isMobile: PropTypes.bool.isRequired,
  collectionData: PropTypes.arrayOf(PropTypes.object),
  setSelectedCollection: PropTypes.func.isRequired,
  displayMoreCollections: PropTypes.bool.isRequired,
  toggleDisplay: PropTypes.func.isRequired,
};

SearchCollection.defaultProps = {
  collectionData: [],
};

SearchCollection.displayName = 'SearchCollection';
export default SearchCollection;
